// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__ycgQL","content":"styles_content__12-ss","checkbox":"styles_checkbox__1OBkJ","checkboxLabel":"styles_checkboxLabel__MZe27"};